export const ROOM_TYPE_OPTIONS = [
  { label: '办公室', value: 'office' },
  { label: '工位', value: 'workstation' },
  { label: '仓储', value: 'warehouse' },
  { label: '其他', value: 'other' }
]

export const ROOM_STATUS_OPTIONS = [
  { label: '未使用', value: 'vacant' },
  { label: '签约中', value: 'reserved' },
  { label: '使用中', value: 'occupied' },
  { label: '停用', value: 'disabled' }
]
